// extracted by mini-css-extract-plugin
module.exports = {"resultsPagination":"pagination_resultsPagination__tbmo2","link":"pagination_link__I8zG2","ant-pagination-item-active":"pagination_ant-pagination-item-active__x9hvf"};